// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.toolbar {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: var(--color_neutral_0);
  border-bottom: 1px solid var(--color_neutral_200);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  align-items: center;
  position: absolute;
  top: -60px;
  z-index: 999;
  min-width: 610px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
.toolbar .colorButton {
  font-size: 14px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
}
.toolbar .colorButton .colorBar {
  margin-top: 2px;
  border: 1px solid var(--color_neutral_800);
  height: 5px;
  width: 16px;
  border-radius: 1px;
}
.toolbar [class^=dist_contextMenuWrapper] {
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.toolbar [class^=dist_contextMenuWrapper]::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.toolbar [class^=dist_contextMenuWrapper]::-webkit-scrollbar-track {
  background: transparent;
}
.toolbar [class^=dist_contextMenuWrapper]::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.toolbar [class^=dist_contextMenuWrapper]:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.toolbar [class^=dist_contextMenuWrapper]::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.toolbar [class^=dist_menuItemButton] {
  min-width: inherit;
}
.toolbar .fontFamilyWrapper [class^=dist_contextMenuWrapper] {
  width: 140px;
}
.toolbar .fontFamilyWrapper [class^=dist_menuItemButton] {
  width: 140px;
}
.toolbar .fontSizeWrapper [class^=dist_contextMenuWrapper] {
  width: 70px;
}
.toolbar .fontSizeWrapper [class^=dist_menuItemButton] {
  width: 70px;
}
.toolbar .redoButton {
  transform: scaleX(-1);
}
.toolbar-group {
  display: flex;
  gap: 8px;
  align-items: center;
  padding-right: 12px;
  border-right: 1px solid var(--color_neutral_200);
}
.toolbar-group:last-child {
  border-right: none;
}
.toolbar .linkButtonWrapper {
  position: relative;
}
.toolbar .linkEditContent {
  position: absolute;
  padding: 16px;
  top: 100%;
  left: 0px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.toolbar .linkEditContent input::placeholder {
  color: var(--color_neutral_500);
}
.toolbar .linkEditContent .buttonsRow {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.toolbar-button {
  background: white;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;
  min-width: 32px;
  padding: 0 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333;
  position: relative;
}
.toolbar-button.boldButton {
  font-weight: 700;
}
.toolbar-button.italicButton {
  font-style: italic;
}
.toolbar-button.underlineButton {
  text-decoration: underline !important;
}
.toolbar-button:hover {
  background-color: var(--color_neutral_200);
}
.toolbar-button.active {
  background-color: var(--color_neutral_200);
  color: #000;
  font-weight: 600;
}

.toolbar.alignLeft {
  left: 0px;
}

.toolbar.alignRight {
  right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/dashboard/text-toolbar/text-toolbar.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,2BAAA;EACA,4BAAA;EACA,wCAAA;EACA,iDAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;AAeF;AAbE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAeJ;AAbI;EACE,eAAA;EACA,0CAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAeN;AAXE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AAaJ;ADnCE;EACE,UAAA;EACA,WAAA;ACqCJ;ADlCE;EACE,uBAAA;ACoCJ;ADjCE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACmCJ;AD/BI;EACE,oCApBS;ACqDf;AD7BE;EACE,oCAxBY;ACuDhB;AA3BE;EACE,kBAAA;AA6BJ;AAzBI;EACE,YAAA;AA2BN;AAxBI;EACE,YAAA;AA0BN;AArBI;EACE,WAAA;AAuBN;AApBI;EACE,WAAA;AAsBN;AAlBE;EACE,qBAAA;AAoBJ;AAjBE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,gDAAA;AAmBJ;AAjBI;EACE,kBAAA;AAmBN;AAfE;EACE,kBAAA;AAiBJ;AAdE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAgBJ;AAdI;EACE,+BAAA;AAgBN;AAbI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAeN;;AAVA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAaF;AAXE;EACE,gBAAA;AAaJ;AAVE;EACE,kBAAA;AAYJ;AATE;EACE,qCAAA;AAWJ;AARE;EACE,0CAAA;AAUJ;AAPE;EACE,0CAAA;EACA,WAAA;EACA,gBAAA;AASJ;;AALA;EACE,SAAA;AAQF;;AALA;EACE,UAAA;AAQF","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.toolbar {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background-color: var(--color_neutral_0);\n  border-bottom: 1px solid var(--color_neutral_200);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px;\n  align-items: center;\n  position: absolute;\n  top: -60px;\n  z-index: 999;\n  min-width: 610px;\n  width: max-content;\n\n  .colorButton {\n    font-size: 14px;\n    font-weight: 700;\n    display: flex;\n    flex-direction: column;\n\n    .colorBar {\n      margin-top: 2px;\n      border: 1px solid var(--color_neutral_800);\n      height: 5px;\n      width: 16px;\n      border-radius: 1px;\n    }\n  }\n\n  [class^='dist_contextMenuWrapper'] {\n    max-height: 200px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    @include scrollbar;\n  }\n\n  [class^='dist_menuItemButton'] {\n    min-width: inherit;\n  }\n\n  .fontFamilyWrapper {\n    [class^='dist_contextMenuWrapper'] {\n      width: 140px;\n    }\n\n    [class^='dist_menuItemButton'] {\n      width: 140px;\n    }\n  }\n\n  .fontSizeWrapper {\n    [class^='dist_contextMenuWrapper'] {\n      width: 70px;\n    }\n\n    [class^='dist_menuItemButton'] {\n      width: 70px;\n    }\n  }\n\n  .redoButton {\n    transform: scaleX(-1);\n  }\n\n  &-group {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    padding-right: 12px;\n    border-right: 1px solid var(--color_neutral_200);\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n\n  .linkButtonWrapper {\n    position: relative;\n  }\n\n  .linkEditContent {\n    position: absolute;\n    padding: 16px;\n    top: 100%;\n    left: 0px;\n    background-color: white;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n\n    input::placeholder {\n      color: var(--color_neutral_500);\n    }\n\n    .buttonsRow {\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-end;\n    }\n  }\n}\n\n.toolbar-button {\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 32px;\n  min-width: 32px;\n  padding: 0 8px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #333;\n  position: relative;\n\n  &.boldButton {\n    font-weight: 700;\n  }\n\n  &.italicButton {\n    font-style: italic;\n  }\n\n  &.underlineButton {\n    text-decoration: underline !important;\n  }\n\n  &:hover {\n    background-color: var(--color_neutral_200);\n  }\n\n  &.active {\n    background-color: var(--color_neutral_200);\n    color: #000;\n    font-weight: 600;\n  }\n}\n\n.toolbar.alignLeft {\n  left: 0px;\n}\n\n.toolbar.alignRight {\n  right: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
